import React from 'react';
import classes from './ExaminationsTab.module.css';
import Modal from '../../Modals/Modal';
import infoIcon from '../../../../assets/icons/info.svg';
import Spinner from '../../Spinner/Spinner';
import PrimaryButtonV2 from '../../Buttons/PrimaryButtonV2';
import { client } from '../../../../networking/client';
import { toast } from 'react-toastify';
import { useTranslation } from '../../../../hooks/useTranslations';

export type DetailType = {
  firstname: string;
  lastname: string;
  higo_patient_id: string;
  person_id: string;
  work_order_id: string;
};

type Props = {
  error: string;
  details: DetailType[];
  isOpen: boolean;
  onClose: () => void;
};

const ErrorDialog: React.FC<Props> = ({ error, details, isOpen, onClose }) => {
  const { translations } = useTranslation();
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [errorDetails, setErrorDetails] = React.useState<DetailType[]>(details);

  const deletePatient = async (work_order_id: string) => {
    setIsLoading(true);
    try {
      await client.delete(`/healthpoint/cancel-examination/${work_order_id}`);
      const patients = errorDetails.filter((error) => error.work_order_id !== work_order_id);
      setErrorDetails(patients);
      if (patients.length === 0) {
        onClose();
      }
    } catch (error: any) {
      toast.error(error.response?.data?.message ?? error.message, {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }
    setIsLoading(false);
  };

  return (
    <Modal
      header={translations('examinations.patient.already.assigned')}
      isOpen={isOpen}
      onClose={onClose}
      maxWidth={'700px'}
      width={'70%'}
      containerPadding={'30px'}
    >
      <div className={classes.errorDialogMessage}>
        <img alt={'info'} src={infoIcon} className={classes.errorDialogIcon} />
        <div style={{ marginTop: 10 }}>{error}</div>
        {isLoading && <Spinner />}
      </div>
      <div className={classes.errorDialogPatientsContainer}>
        {errorDetails.map((detail, index) => (
          <div key={index} className={classes.errorDialogPatientCard}>
            <div style={{ flex: 1 }}>
              <div style={{ margin: '5px 0' }}>
                {translations('examinations.patient')}:{' '}
                <strong>
                  {detail.firstname} {detail.lastname}
                </strong>
              </div>
              <div style={{ margin: '5px 0' }}>
                {translations('examinations.work.order.id')}:{' '}
                <strong>{detail.work_order_id}</strong>
              </div>
              <div style={{ margin: '5px 0' }}>
                {translations('examinations.patient.higo.id')}:{' '}
                <strong>{detail.higo_patient_id}</strong>
              </div>
              <div style={{ margin: '5px 0' }}>
                {translations('examinations.person.id')}: <strong>{detail.person_id}</strong>
              </div>
            </div>
            <PrimaryButtonV2
              text={translations('examinations.unassign')}
              buttonStyle={{
                height: 50,
              }}
              onClick={() => deletePatient(detail.work_order_id)}
            />
          </div>
        ))}
      </div>
    </Modal>
  );
};

export { ErrorDialog };
